<template>
  <nav class="portal-nav" :class="{ 'portal-nav--cbia': $webType === 'cbia' }" aria-label="主导航" @keydown.esc="hideMenus">
    <div class="nav-inner">
      <router-link class="nav-logo" to="/home" @click.native="mobileOpen = false; open = false">
        <img :src="logoImg" alt="" width="28" height="28">
        <span>{{ $webType === 'cbia' ? 'CBIA企业服务平台' : $portalText('navigation', 'siteName') }}</span>
      </router-link>
      <div class="nav-content">
        <div class="nav-list">
          <button v-for="(item, index) in menus" :key="index" ref="menuItems" type="button" :class="['list-item', activeMenuStatus(index)]" :aria-expanded="navigationChildren(item).length ? String(open && mouseIndex === index) : undefined" @mouseenter="mouseenter(item, index)" @focus="mouseenter(item, index)" @click="selectPrimary(item, index)">
            {{ item.title }}<span v-if="navigationChildren(item).length" class="nav-chevron" aria-hidden="true"></span>
          </button>
        </div>
        <div class="nav-action">
          <template v-if="$webType === 'cbia'">
            <Button class="action-login" size="small" @click="openLink">{{ $portalText('navigation', 't001') }}</Button>
            <Button class="action-download" type="primary" size="small" @click="downloadUrl('/download')">{{ $portalText('navigation', 't002') }}</Button>
          </template>
          <template v-if="$webType === 'dpp'">
            <div v-if="$route.path.replace(/\/$/, '') === '/home'" class="action-search">
              <Input :placeholder="$portalText('navigation', 't004')" :aria-label="$portalText('navigation', 't004')" v-model="searchKeyWords" size="small" @keyup.enter.native="findSearch"><Button slot="append" icon="el-icon-search" :aria-label="$portalText('navigation', 't003')" @click="findSearch" /></Input>
            </div>
            <router-link to="/trial/" class="trial-entry-link" @click.native="mobileOpen = false; open = false">{{ $portalText('navigation', 't005') }}</router-link>
          </template>
        </div>
      </div>
      <button ref="menuToggle" class="nav-menu-toggle" type="button" :aria-expanded="String(mobileOpen)" aria-controls="portal-mobile-menu" :aria-label="mobileOpen ? '关闭导航菜单' : '打开导航菜单'" @click="mobileOpen = !mobileOpen; open = false"><span></span><span></span></button>
    </div>
    <div v-if="open && navigationChildren(itemInfo).length" class="nav-megamenu" @mouseleave="open = false">
      <div class="nav-megamenu-links"><button v-for="(child, index) in navigationChildren(itemInfo)" :key="child.path" type="button" @click="navigateMenu(child, index)">{{ child.title }}<span aria-hidden="true">↗</span></button></div>
      <aside v-if="itemInfo.tips" class="nav-megamenu-note"><p>{{ itemInfo.tips.join(' · ') }}</p><router-link v-if="$webType === 'dpp'" to="/trial/" @click.native="open = false">了解 DCMP 企业试用 <span aria-hidden="true">→</span></router-link></aside>
    </div>
    <div v-if="mobileOpen" id="portal-mobile-menu" class="nav-mobile-menu">
      <div v-for="(item, index) in menus" :key="index" class="nav-mobile-group">
        <template v-if="navigationChildren(item).length"><p>{{ item.title }}</p><button v-for="(child, childIndex) in navigationChildren(item)" :key="child.path" type="button" @click="navigateMenu(child, childIndex)">{{ child.title }}<span aria-hidden="true">›</span></button></template>
        <button v-else type="button" @click="navigateMenu(item, index)">{{ item.title }}<span aria-hidden="true">›</span></button>
      </div>
    </div>
  </nav>
</template>

<script>
import { portalData } from '@/portal/runtime';

import logoImg from '@/assets/images/portal/logo.png';
import frameOneImg from '@/assets/images/portal/frame_one.png';
import frameTwoImg from '@/assets/images/portal/frame_two.png';
import frameThreeImg from '@/assets/images/portal/frame_three.png';
import arrowIcon from '@/assets/images/portal/arrow.png';
import arrowActiveIcon from '@/assets/images/portal/arrow_active.png';
import chevronDownIcon from '@/assets/images/sliderNav/chevron-down.png';
import arrowRightIcon from '@/assets/images/sliderNav/arrow-right.png';
import userIcon from '@/assets/images/sliderNav/user-icon.png';
import downloadIcon from '@/assets/images/sliderNav/download-icon.png';
import { Button, Input } from 'element-ui';
export default {
  portalScope: 'navigation',
    components: {
        Input,
        Button
    },
    data() {
        return portalData('navigation', {
            userIcon,
            downloadIcon,
            isFirstFindNode: false,
            searchKeyWords: '',
            clickIndex: 0,
            mouseIndex: 0,
            // isDownload: false,
            arrowIcon,
            arrowActiveIcon,
            chevronDownIcon,
            arrowRightIcon,
            open: false,
            mobileOpen: false,
            logoImg,
            itemInfo: {},
            menus: [
                {
                    // 首页
                    title: '首页', path: '/home'
                },
                {
                    // 关于DPP
                    type: 'menu',
                    title: '关于DPP', path: '#',
                    routeVertials: [
                        { title: '关于DPP', path: '/aboutdpp' },
                        { title: '权威报告', path: '/technicalReport' },
                        { title: '技术标准', path: '/technicalStandard' }
                    ],
                    routeLevels: [
                        [
                            { title: '什么是产品数字护照?', path: '/aboutdpp#what' },
                            { title: '产品数字护照实施过程', path: '/aboutdpp#process' },
                            { title: '产品数字护照意义', path: '/aboutdpp#significance' }
                        ],
                        [
                            { title: '权威报告', path: '/technicalReport#report' },
                            { title: '中国电池数字护照体系白皮书', path: '/technicalReport#digitalize' }
                        ],
                        [
                            { title: '技术标准', path: '/technicalStandard#standard' }
                        ]
                    ],
                    indexs: [1],
                    img: frameOneImg,
                    tips: ['助力企业', '数字化转型'],
                    labels: ['申请试用', '申请试用, 与优秀企业家建联, 共建行业前瞻洞见.', '立即前往'],
                },
                {
                    // 电池数字护照
                    type: 'menu',
                    title: '产品数字护照', path: '#',
                    routeVertials: [
                        { title: '电池DPP', path: '/batteryIndustry' },
                        { title: '企业碳管理', path: '/carbonManage' }
                    ],
                    routeLevels: [
                        [
                            { title: '欧盟背景', path: '/batteryIndustry#unionBackground' },
                            { title: '市场现状', path: '/batteryIndustry#marketSituation' },
                            { title: '电池DPP的价值意义', path: '/batteryIndustry#valueSignificance' },
                            { title: '项目方案', path: '/batteryIndustry#projectPlan' }
                        ],
                        [
                            { title: '企业正面临着碳管理的挑战', path: '/carbonManage#challenge' },
                            { title: '应用场景', path: '/carbonManage#application' },
                            { title: '核心价值', path: '/carbonManage#coreValue' }
                        ]
                    ],
                    indexs: [2],
                    img: frameTwoImg,
                    tips: ['电池', '数字护照']
                },
                {
                    // 新闻动态
                    title: '新闻动态', path: '#',
                    routeLevels: [
                        [
                            { title: '政策解读', path: '/policyComment' },
                            { title: '行业资讯', path: '/industryInformation' },
                            { title: '工作动态', path: '/workNews' }
                        ]
                    ],
                    routeContent: {
                        title: '新闻动态',
                        label: '了解欧盟相关法规，行业资讯，技术，案例和生态, 带您见证产品数字护照带来的增长新动力。'
                    },
                    indexs: [3],
                    img: frameThreeImg,
                    tips: ['助力企业', '数字化转型']
                },
                { title: '关于我们', path: '/aboutUs' },
                { title: 'F.A.Q.', path: '/faq' }
            ],
        })
    },
    created() {
        this.$nextTick(() => {
            this.defaultActive(this.menus);
        })
    },
    mounted() { document.addEventListener('click', this.onOutsideNav); },
    beforeDestroy() { document.removeEventListener('click', this.onOutsideNav); },
    computed: {
        // 滑块弹出验证状态
        sliderStatus() {
            return (index) => this.open ? `slider-open-mode${index}` : `slider-close-mode`;
        },
        // 菜单激活状态
        activeMenuStatus() {
            return (index) => {
                return [
                    this.clickIndex == index ? 'active' : null,
                    this.mouseIndex == index ? 'mouseActive' : null
                ]
            }
        },
    },
    watch: {
        '$route.path': {
            immediate: true,
            handler(value) {
                this.defaultActive(this.menus);
                this.mobileOpen = false; this.open = false;
                if (value.includes('/download')) {
                    this.clickIndex = -1;
                    this.mouseIndex = -1;
                    this.open = false;
                }
            }
        }
    },
    methods: {
        navigationChildren(item) {
            const values = [...(item.routeVertials || []), ...(item.routeLevels || []).flat()];
            const seen = new Set();
            return values.filter(child => child && child.path && child.path !== '#' && !seen.has(child.path) && seen.add(child.path));
        },
        selectPrimary(item, index) {
            if (this.navigationChildren(item).length) { this.itemInfo = item; this.mouseIndex = index; this.open = !this.open; return; }
            this.mouseclick(item, index, 'parent');
        },
        navigateMenu(item, index) { this.mobileOpen = false; this.open = false; this.mouseclick(item, index, 'children'); },
        hideMenus() {
            const wasMobile = this.mobileOpen; this.mobileOpen = false; this.open = false;
            this.$nextTick(() => { const target = wasMobile ? this.$refs.menuToggle : (this.$refs.menuItems || [])[this.mouseIndex]; if (target) target.focus(); });
        },
        onOutsideNav(event) { if (!this.$el.contains(event.target)) { this.mobileOpen = false; this.open = false; } },
        // 获取默认的激活菜单状态
        defaultActive(menus) {
            const current = this.$route.path.replace(/\/$/, '');
            const matches = item => item && typeof item.path === 'string' && item.path.split('#')[0].replace(/\/$/, '') === current;
            const index = menus.findIndex(item => matches(item) || (item.routeVertials || []).some(matches) || (item.routeLevels || []).flat().some(matches));
            this.clickIndex = index;
            this.mouseIndex = index;
        },
        // 鼠标移进
        mouseenter(item, index) {
            if (!item.children || this.mouseIndex != index) {
                this.mouseIndex = index;
                this.open = false;
            }
            this.itemInfo = item;
            this.open = true;
        },
        // 鼠标移出
        mouseleave(e) {
            if (e.relatedTarget && e.relatedTarget.className == 'portal-nav') return;
            this.mouseIndex = this.clickIndex;
            this.open = false;
        },
        // 鼠标点击
        mouseclick(item, index, level) {
            this.searchKeyWords = '';
            if ((item.routeVertials || item.routeLevels) && (!item.path || item.path === '#') && level == 'parent') return;
            let addHashRoutePath = this.$route.path + this.$route.hash;
            if (item.path && /^https?:\/\//i.test(item.path)) { window.open(item.path, '_blank', 'noopener'); return; }
            if (item.path && item.path !== '#' && item.path != addHashRoutePath) this.$router.push(item.path).catch(() => {});
            this.clickIndex = level == 'children' ? this.mouseIndex : index;
            this.open = false;
        },
        // 路由跳转
        convertUrl(url) {
            this.open = false;
            if (this.$route.path != url) {
                this.$router.push(url);
                if (url == '/home') {
                    this.clickIndex = 0;
                    this.mouseIndex = 0;
                }
            }
        },
        openLink() {
            window.open('https://platform.cbpassport.com/', '_blank');
        },
        downloadUrl(url) {
            if (this.$route.path != url) {
                this.$router.push(url);
            }
        },
        findSearch() {
            const allNodes = document.querySelectorAll('.page');
            const nodesArray = Array.prototype.slice.call(allNodes);
            this.findSearchKeyWords(this.searchKeyWords, nodesArray);
        },
        findSearchKeyWords(keyWords, nodes) {
            this.isFirstFindNode = false;
            for (let i = 0; i < nodes.length; i++) {
                let item = nodes[i];
                if (item.children && item.children.length) {
                    this.findSearchKeyWords(keyWords, item.children);
                    if (this.isFirstFindNode) {
                        document.querySelectorAll('.set-keywords').forEach((item, index) => {
                            if (index != 0) item.parentNode.replaceChild(document.createTextNode(`${item.innerText}`), item);
                        });
                        break;
                    }
                } else {
                    if (item.classList.contains('set-keywords')) {
                        let cacheCurrentParentNode = item.parentNode;
                        item.parentNode.replaceChild(document.createTextNode(`${item.innerText}`), item);
                        this.handleNodeInfo(cacheCurrentParentNode, keyWords);
                    } else {
                        this.handleNodeInfo(item, keyWords);
                    }
                    document.querySelectorAll('.set-keywords').forEach((item, index) => {
                        if (index == 0) item.scrollIntoView({ behavior: 'smooth', block: 'center' });
                    })
                }
            }
        },
        handleNodeInfo(item, keyWords) {
            if (item.innerText.indexOf(keyWords) != -1 && keyWords != '') {
                let newHtml = '';
                this.isFirstFindNode = true;
                item.innerText.split(keyWords).forEach((element, index) => {
                    if (index == 0) {
                        newHtml += element + '<span class="set-keywords" style="color: #0060dd;font-weight: bold;">' + keyWords + '</span>';
                    } else {
                        newHtml += element;
                    }
                });
                item.innerHTML = newHtml.trim();

            }
        }
    }
}
</script>
<style scoped>
.portal-nav { position: sticky; top: 0; z-index: 40; width: 100%; margin: 0; padding: 0 32px; border-bottom: 1px solid #e8ecef; background: rgba(255,255,255,.96); color: #37414b; font-family: -apple-system,BlinkMacSystemFont,"Segoe UI","PingFang SC","Microsoft YaHei",sans-serif; font-size: 14px; line-height: 1.5; backdrop-filter: blur(18px); }
.portal-nav *, .portal-nav ::v-deep * { box-sizing: border-box; font-family: inherit; font-size: inherit; flex-shrink: 1; }
.nav-inner { display: flex; align-items: center; gap: 40px; width: 100%; max-width: 1280px; min-height: 64px; margin: 0 auto; }
.nav-logo { display: inline-flex; align-items: center; flex: 0 1 auto; gap: 10px; min-width: 0; max-width: 280px; color: #1e3442; text-decoration: none; }
.nav-logo img { flex: 0 0 28px; display: block; width: 28px; height: 28px; object-fit: contain; }
.nav-logo span { overflow: hidden; text-overflow: ellipsis; white-space: nowrap; font-size: 17px; font-weight: 600; letter-spacing: -.02em; }
.nav-content { display: flex; flex: 1; align-items: center; justify-content: space-between; gap: 24px; min-width: 0; }
.nav-list { display: flex; align-items: center; gap: 26px; }
.list-item { display: inline-flex; align-items: center; gap: 7px; min-height: 44px; padding: 8px 0; border: 0; background: none; color: #414147; font-size: 14px; white-space: nowrap; cursor: pointer; }
.list-item:hover, .list-item.active { color: #006b80; }
.list-item.active { font-weight: 600; }
.nav-chevron { display: inline-block; width: 6px; height: 6px; border-right: 1px solid currentColor; border-bottom: 1px solid currentColor; transform: rotate(45deg); margin-top: -3px; }
.nav-action { display: flex; align-items: center; gap: 12px; }
.trial-entry-link { display: inline-flex; align-items: center; justify-content: center; min-height: 44px; padding: 11px 20px; border: 1px solid #006b80; border-radius: 22px; background: #006b80; color: #fff; font-size: 14px; font-weight: 500; line-height: 20px; white-space: nowrap; text-decoration: none; transition: background-color 150ms ease; }
.trial-entry-link:hover { background: #005569; border-color: #005569; color: #fff; }
.portal-nav button:focus-visible, .portal-nav a:focus-visible { outline: 3px solid #86b9c6; outline-offset: 4px; border-radius: 6px; }
.action-search { width: 160px; }
.action-search ::v-deep .el-input__inner { height: 36px; line-height: 36px; border-radius: 8px 0 0 8px; font-size: 13px; padding: 0 12px; }
.action-search ::v-deep .el-input-group__append { padding: 0 14px; border-radius: 0 8px 8px 0; }
.nav-menu-toggle { display: none; flex: 0 0 40px; flex-direction: column; align-items: center; justify-content: center; gap: 6px; width: 40px; height: 40px; border: 1px solid #e1e7eb; border-radius: 10px; background: #fff; color: #314553; cursor: pointer; }
.nav-menu-toggle span { display: block; width: 17px; height: 1.5px; border-radius: 1px; background: currentColor; }
.nav-megamenu { position: absolute; left: 50%; top: calc(100% + 1px); display: grid; grid-template-columns: minmax(0, 1fr) 220px; gap: 32px; width: min(1100px, calc(100vw - 64px)); padding: 28px; border: 1px solid #e8ecef; border-radius: 0 0 16px 16px; background: #fff; box-shadow: 0 18px 40px rgba(26,42,52,.08); transform: translateX(-50%); }
.nav-megamenu-links { display: grid; grid-template-columns: repeat(2,minmax(0,1fr)); gap: 8px 24px; }
.nav-megamenu button { display: flex; align-items: center; justify-content: space-between; gap: 12px; width: 100%; min-height: 44px; padding: 10px 12px; border: 0; border-radius: 8px; background: #fff; color: #47535e; font-size: 14px; text-align: left; cursor: pointer; }
.nav-megamenu button:hover { color: #006b80; background: #f1f7f8; }
.nav-megamenu button span { color: #8aa0aa; }
.nav-megamenu-note { padding: 14px 20px; border-left: 1px solid #e8ecef; color: #596772; font-size: 14px; line-height: 1.8; }
.nav-megamenu-note a { display: inline-block; margin-top: 24px; color: #006b80; font-size: 13px; }
.nav-mobile-menu { display: none; }
@media (max-width: 1340px) { .nav-inner { gap: 28px; } .nav-list { gap: 18px; } .nav-content { gap: 20px; } .action-search { display: none; } }
@media (max-width: 1120px) {
 .portal-nav { padding: 0 24px; } .nav-inner { min-height: 60px; gap: 16px; } .nav-logo { max-width: none; flex: 1; } .nav-content { flex: 0 0 auto; } .nav-list, .nav-megamenu { display: none; } .nav-menu-toggle { display: flex; }
 .nav-mobile-menu { position: absolute; top: calc(100% + 1px); right: 24px; display: block; width: min(380px, calc(100vw - 48px)); max-height: min(74vh, 680px); overflow-y: auto; padding: 12px; border: 1px solid #e4e9ed; border-radius: 0 0 14px 14px; background: #fff; box-shadow: 0 16px 36px rgba(26,42,52,.12); overscroll-behavior: contain; }
 .nav-mobile-group { padding: 6px 0; } .nav-mobile-group + .nav-mobile-group { border-top: 1px solid #edf0f2; }
 .nav-mobile-group p { margin: 4px 12px; color: #7a8790; font-size: 12px; line-height: 24px; }
 .nav-mobile-group button { display: flex; align-items: center; justify-content: space-between; gap: 12px; min-height: 44px; width: 100%; padding: 10px 12px; border: 0; border-radius: 8px; background: #fff; color: #314553; font-size: 14px; text-align: left; cursor: pointer; }
 .nav-mobile-group button:hover { color: #006b80; background: #f0f7f8; } .nav-mobile-group button span { color: #83929c; font-size: 20px; }
}
@media (max-width: 600px) { .portal-nav { padding: 0 16px; } .nav-inner { gap: 10px; } .nav-logo { gap: 8px; } .nav-logo span { font-size: 14px; } .nav-logo img { width: 26px; height: 26px; flex-basis: 26px; } .trial-entry-link { min-height: 44px; padding: 11px 14px; font-size: 13px; } .nav-mobile-menu { right: 16px; width: calc(100vw - 32px); } .portal-nav--cbia .action-download { display: none; } }
@media (max-width: 359px) { .nav-logo span { max-width: 108px; } .nav-inner { gap: 8px; } .trial-entry-link { padding: 8px 10px; } .nav-menu-toggle { width: 36px; flex-basis: 36px; } }
@media (prefers-reduced-motion: reduce) { .portal-nav * { transition: none; } }

</style>
